/**
 * THIS FILE IS FOR HELPER FUNCTIONS THAT CAN BE USED REPETETIVELY THROUGHOUT THE APP
 * FOR MORE CONSISITENT UI.
 */
import { countryConstants } from '../contexts/LanguageTranslation/CountryConstants';

// Return random 5-7 digit key for use in mapping/keys/ids.
// IMPORTANT: Use for UI only, not for anything that needs to be secure.
// Not "truly" random enough for security purposes.
export const randomized = () => Math.random().toString(36).substring(7);

// takes ANY numeric string and returns a phone number formatted the correct way.
// CORRECT: (123) 456-7890
// INCORRECT: 848-484-4848, 939 393 9393, (848)484-4848, 2828282828
export function phoneFormat(phone) {
    //normalize string and remove all unnecessary characters
    const cleaned = phone.replace(/[^\d]/g, '');

    //check if number length equals to 10
    if (cleaned.length == 10) {
        //reformat and return phone number
        return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }

    return phone;
}

// STRIP phone number is primarily for
export function stripPhoneNumber(phone, country = 'US') {
    const stripped = phone?.replace(/[^\d]/g, '');
    if (country !== 'US') {
        return `${countryConstants[country].phone.countryCode}${stripped}`;
    }
    return stripped;
}

export const findMyLink = (language, country) => {
    const langCode = `${language?.toUpperCase()}-${country?.toUpperCase()}`;

    switch (langCode) {
        case 'SG-CH':
            return 'https://support.apple.com/de-ch/102648';
        case 'FR-CH':
            return 'https://support.apple.com/fr-ch/102648';
        case 'FR-FR':
            return 'https://www.apple.com/fr/icloud/find-my/';
        case 'FI-FI':
            return 'https://support.apple.com/fi-fi/102648';
        case 'DA-DK':
            return 'https://support.apple.com/da-dk/102648';
        case 'CL-CL':
        case 'ES-CL':
            return 'https://www.apple.com/cl/icloud/find-my/';
        case 'ES-ES':
            return 'https://www.apple.com/es/icloud/find-my/';
        case 'MX-MX':
        case 'ES-MX':
            return 'https://www.apple.com/mx/icloud/find-my/';
        case 'AT-AT':
        case 'DE-AT':
            return 'https://support.apple.com/de-at/102648';
        case 'DE-DE':
            return 'https://www.apple.com/de/icloud/find-my/';
        case 'IT-CH':
            return 'https://support.apple.com/it-it/102648';
        case 'IT-IT':
            return 'https://www.apple.com/it/icloud/find-my/';
        case 'JA-JP':
            return 'https://www.apple.com/jp/icloud/find-my/';
        case 'NL-NL':
            return 'https://support.apple.com/nl-nl/102648';
        case 'NO-NO':
            return 'https://support.apple.com/no-no/102648';
        case 'SV-SE':
            return 'https://support.apple.com/sv-se/102648';
        case 'EN-AUS':
            return 'https://www.apple.com/au/icloud/find-my/';
        case 'EN-US':
            return 'https://www.apple.com/icloud/find-my/';
        case 'EN-UK':
            return 'https://www.apple.com/uk/icloud/find-my/';
        case 'EN-IE':
            return 'https://support.apple.com/en-ie/102648';
        case 'EN-IN':
            return 'https://www.apple.com/in/icloud/find-my/';
        case 'EN-NZ':
            return 'https://www.apple.com/nz/icloud/find-my/';
        case 'EN-AT':
        case 'EN-CL':
        case 'EN-DE':
        case 'EN-DK':
        case 'EN-FI':
        case 'EN-FR':
        case 'EN-IT':
        case 'EN-JP':
        case 'EN-MX':
        case 'EN-NL':
        case 'EN-NO':
        case 'EN-ES':
        case 'EN-CH':
        case 'EN-SE':
            return 'https://support.apple.com/en-us/102648';
        default:
            return 'https://www.apple.com/icloud/find-my/';
    }
};
